import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: "auth",
    initialState: {
        user: null,
        forgotPwd: {
          forgotPwdToken: null,
          forgotPwdEmail: null
        },
        signUpSuccessData: null,
        partialLoginData: null,
        forgetPincodeTokenPartialLogin: null,
        isAdditionalParent: false,
        blockUser: {},
    },
    reducers: {
      setUser: (state, action) => {
        state.user = action?.payload;
      },
      setForgotPwdToken: (state, action) => {
        state.forgotPwd = action?.payload;
      },
      setSignUpSuccessData: (state, action) => {
        state.signUpSuccessData = action?.payload;
      },
      setPartialLoginData: (state, action) => {
        state.partialLoginData = action?.payload;
      },
      setTokenPinPartialLogin: (state, action) => {
        state.forgetPincodeTokenPartialLogin = action?.payload;
      },
      setIsAdditionalParent: (state, action) => {
        state.isAdditionalParent = action?.payload;
      },
      blockUser: (state, action) => {
        const { email, failedCount } = action.payload;
        state.blockUser[email] = {
          lastTimeLoggedIn: Date.now(),
          failedCount,
        };
      },
      resetBlockUser: (state, action) => {
        const email = action.payload;
        delete state.blockUser[email];
      },
      removeItem: (state, action) => {
        if(action?.payload === 'user') {
          state.user = null;
        } else if(action?.payload === 'forgotPwd') {
          state.forgotPwd = {
            forgotPwdToken: null,
            forgotPwdEmail: null
          };
        } else if(action?.payload === 'SIGN_UP_SUCCESS') {
          state.signUpSuccessData = null;
        }
      },
      clearAuthState: (state) => {
        state.user = null;
        state.forgotPwd = {
          forgotPwdToken: null,
          forgotPwdEmail: null
        };
        state.signUpSuccessData = null;
        state.partialLoginData = null;
        state.forgetPincodeTokenPartialLogin = null;
        state.isAdditionalParent = false;
        state.blockUser = {};  // Clear all blocked users on logout
      }
    }
  });

// Export actions for use in components
export const { 
  setUser, 
  removeItem, 
  setForgotPwdToken, 
  setSignUpSuccessData, 
  clearAuthState, 
  setPartialLoginData, 
  setTokenPinPartialLogin, 
  setIsAdditionalParent,
  blockUser,  // Action for blocking user
  resetBlockUser,
} = authSlice.actions;

export default authSlice.reducer;
